/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".smartbanner{position:fixed;top:unset;bottom:0}@media (max-width:700px){.vc-col-sm-0{display:none!important}}div:focus{outline:0}"];
export { styles as styles };
